export const statusMap = {
  0: { text: '待审核', class: 'text-red-600' },
  1: { text: '待结算', class: 'text-blue-500' },
  2: { text: '已结算', class: 'text-green-600' },
  3: { text: '已驳回', class: 'text-yellow-600' },
};

export const columns = [
  {
    title: '申请编号',
    dataIndex: 'apply_no',
    width: 130,
  },
  {
    title: '申请时间',
    dataIndex: 'create_time',
    width: 170,
  },
  {
    title: '申请人',
    dataIndex: 'apply_user_name',
    scopedSlots: { customRender: 'apply_user' },
    width: 120,
  },
  {
    title: '订单数量',
    dataIndex: 'contract_count',
    width: 90,
  },
  {
    title: '业绩',
    dataIndex: 'leader_commission',
    scopedSlots: { customRender: 'performance' },
    width: 120,
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    width: 90,
  },
  {
    title: '结算时间',
    dataIndex: 'settle_time',
    width: 170,
  },
];

export const statusText = (status) => {
  const s = statusMap[status];
  return s ? s.text : '-';
};

export const statusClass = (status) => {
  const s = statusMap[status];
  return s ? s.class : '';
};
